import { queryClient } from "App";
import { get } from "lodash";
import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import {
  getRegionsTableColumns,
  getRegionsTableFilters,
} from "routes/regions/components/RegionsTableColumnsAndFilters";
import UserService from "services/User";
import { addResizedColumns } from "./useTableConfig";

export const invalidateRegionsTableQuery = async () => {
  await queryClient.invalidateQueries({ queryKey: ["regions"] });
};

export const useRegionsTable = ({ tableName = "regions" }) => {
  const { data: tableSettings, isSuccess: isTableSettingsFetched } = useQuery({
    queryKey: ["table-settings"],
    queryFn: UserService.getUserSettings,
  });

  const filters = useMemo(() => {
    return getRegionsTableFilters();
  }, []);

  const columns = useMemo(() => {
    if (!isTableSettingsFetched) return [];

    const initialColumns = getRegionsTableColumns({
      onSuccess: invalidateRegionsTableQuery,
    });

    const regionsTableSettings = get(
      tableSettings,
      `user_settings.preferences.tables.${tableName}`,
      {}
    );

    const withResizedColumns = addResizedColumns({
      columns: initialColumns,
      resizedColumns: regionsTableSettings?.resized_columns || {},
    });

    return withResizedColumns;
  }, [tableName, tableSettings, isTableSettingsFetched]);

  return { filters, columns };
};
